import { useEffect, useMemo, useState } from "react";

/**
 * Client-side pagination for already-loaded lists.
 * Shows `pageSize` rows per page and resets to page 1 when `resetKey` changes
 * (e.g. the active search term or filter), so the user always lands on page 1
 * after narrowing the list.
 */
export function usePagination(items, pageSize = 100, resetKey = "") {
  const [page, setPage] = useState(1);
  const list = items || [];
  const total = list.length;
  const pageCount = Math.max(1, Math.ceil(total / pageSize));

  useEffect(() => {
    setPage(1);
  }, [resetKey]);

  useEffect(() => {
    if (page > pageCount) setPage(pageCount);
  }, [pageCount, page]);

  const pageItems = useMemo(
    () => list.slice((page - 1) * pageSize, page * pageSize),
    [list, page, pageSize]
  );

  return { page, setPage, pageCount, total, pageItems, pageSize };
}
